export default __webpack_public_path__ + "static/media/ic_cash.c0c2baab.svg";